import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "./HelpAssistant.css";
import femaleuser from "../../images/img/female-user.png";
import helpicon from "../../images/img/chat-helpicon-top.png";
import apiService from "../APIService";
import backtopmenu from "../../images/img/backtopmenu-arrow.svg";
import sendIcon from "../../images/icons/send.svg";
import sendIconGrey from "../../images/icons/send-gray.svg";
import Conversation from "../Conversation/Conversation";
import "../CoachScreen.css";
import "../css/gethelp-responsive.css";
import {
  sendOnAppClose,
  sendOnAppOpen,
} from "../../Simplify360Chat/Services/HWIframeBridge";
import { stubTrue } from "lodash";
import { Constants } from "../../Constants/Constants";
import FeedBackIframe from "../../Simplify360Chat/CommonUtils/FeedBackIframe";
import ToastMessage from "../Conversation/Utils/Toast/ToastMessage";
import MessageA13Nudge from "../Conversation/MessageCodes/MessageA13Nudge";
import secureLocalStorage from "react-secure-storage";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const HelpAssistant = (props) => {
  const [onClickYes, setOnClickYes] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(true);
  const [typedFlag, setTypedFlag] = useState("");
  const [show, setShow] = useState(false);
  const [clearHistory, setClearHistory] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [showMinimize, setShowMinimize] = useState(false);
  const [conversation, setConversation] = useState(false);
  const [showAssistantToolTip, setShowAssistantToolTip] = useState(false);
  const [showChatToolTip, setShowChatToolTip] = useState(false);
  const [conversationData, setConversationData] = useState();
  const [chatHistory, setChatHistory] = useState([]);
  const [showRechargeToast, setShowRechargeToast] = useState(false);
  const [sendText, setSendText] = useState();
  const [showWhatsappBanner, setShowWhatsappBanner] = useState(true);
  const [showWhatsappRegisterPopup, setShowWhatsappRegisterPopup] =
    useState(false);
  const [feedbackUrl, setFeedBackUrl] = useState(null);
  const [historyData, setHistoryData] = useState();
  const [changedRefresh, setChangedRefresh] = useState(false);
  const [showSecondOk, setShowSecondOk] = useState(false);
  const [thirdOkay, setThirdOkay] = useState(false);
  const [sth, setSth] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [loginLoader, setLoginLoader] = useState(true);
  const [name, setName] = useState();
  const [login, setLogin] = useState(false);
  const [enableDefaultTextBox, setEnableDefaultTextBox] = useState(false);
  const [auth, setAuth] = useState(props.authenticated);
  const [textMessage, setTextMessage] = useState("");
  const [backToMenuRender, setBackToMenuRender] = useState(false);
  const [minimized, setMinimized] = useState(
    props.launchOnButton !== undefined && props.launchOnButton ? false : true
  );
  const [showVersion, setShowVersion] = useState(false);
  const [showFeedBackIframe, setShowFeedBackIframe] = useState(false);
  const [maximized, setMaximized] = useState(true);
  const [outSideLink, setOutSideLink] = useState(true);
  const [overlayVisible, setOverlayVisible] = useState(true);
  const [tempLinkDetails, setTempLinkDetails] = useState(null);
  const [actionFromConfig, setActionFromConfig] = useState(null);
  const [jumpNode, setJumpNode] = useState(true);
  const [chatData, setChatData] = useState([]);
  const [showOverlay, setshowOverlay] = useState(false);
  //new addition 1
  const [isLoading, setIsLoading] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [showChatInProgressToolTip, setShowChatInProgressToolTip] =
    useState(false);
  const [loggedInTillrefresh, setLoggedInTillrefresh] = useState(false);
  const [agentScreen, setAgentScreen] = useState(false);
  const [loadingInagent, setLoadingInAgent] = useState(true);
  // console.log("action from config in HELPASSISTANT.JS", props);
  const [agentInfo, setAgentInfo] = useState(null);
  const [agentConnected, setAgentConnected] = useState(false);
  const [agentHeader, setAgentHeader] = useState(false);
  const [chatClosed, setChatClosed] = useState(false);
  const messageRef = useRef(null);
  const [agentUserData, setAgentUserData] = useState(null);
  const [genesysWindowUpdate, setgenesysWindowUpdate] = useState(null);
  const [toast, setToast] = useState(false);
  const [interactionId, setIntereactionId] = useState("");

  const [reminderValue, setReminderValue] = useState({});

  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const [showIdlePopup, setShowIdlePopup] = useState(false);

  const [isChatWithUs, setIsChatWithUs] = useState(false);

  const [isDunningToast, setIsDunningToast] = useState(false);

  const [userNotification, setUserNotification] = useState({});

  const [continueJourney, setContinueJourney] = useState(false);
  const [nudgeData, setNudgeData] = useState(null);
  const [showFeedbackPopUP, setShowFeedbackPopUP] = useState(null);

  const [stateSessionId, setStateSessionId] = useState(null);
  var tempAgentData = null;
  const { coachingData, src } = props;

  useEffect(() => {
    if (coachingData === false && src !== "ua" && src !== "Deep link" && src !== "us" && src !== 'US' && src !== 'UA' && src !== 'BingeBot') {
      handleButtonClick();
    }
  }, [coachingData]);

  const handleButtonClick = () => {
              setshowOverlay(false);
              window.parent.postMessage(
                {
                  chatMinimized: "true",
                },
                "*" //or "www.parentpage.com"
              );
              setShowSecondOk(true);

              // coachScreenCloseFunc();
              sendOnAppOpen();
              setShowAssistantToolTip(true);
              setThirdOkay(true);
              setTimeout(() => {
                setShowAssistantToolTip(false);
              }, 4000);

              //  setShow(true);

              //url has action then dont run it
              if (props.action) {
                setMinimized(true);
                //action exists in url
              } else {
                // setMinimized(false);
              }
  };
  const formatNotificationText = (text) => {
    const parts = text.split(/<strong>|<\/strong>/);
    return (
      <span>
        {parts[0]}
        <strong>{parts[1]}</strong>
        {parts[2]}
      </span>
    );
  };

  // localStorage.setitem()
  const extractFromUrl = (url) => {
    var splitArray = [];

    const queryParams = new URLSearchParams(url);

    for (const [key, value] of queryParams) {
      splitArray.push({ key, value });
      // {key: 'term', value: 'pizza'} {key: 'location', value: 'Bangalore'}
    }
    var ExtractedUrlTemp = splitArray.reduce(
      (a, item) => Object.assign(a, { [item.key]: item.value }),
      {}
    );

    let extractedURl = new Object();
    //this code can be modified based on url format
    //*****************************************
    extractedURl.authenticated = ExtractedUrlTemp.authenticated || false;
    extractedURl.subscriberId = ExtractedUrlTemp.subId;
    extractedURl.action = ExtractedUrlTemp.action || "1";
    extractedURl.src = ExtractedUrlTemp.src || "Deep Link";
    //*****************************************
    console.log("extractedUrl", extractedURl);
    // console.log("enableDefaultTextBox",enableDefaultTextBox)
    if (
      extractedURl.action != undefined &&
      (extractedURl.authenticated != undefined ||
        extractedURl.subId != undefined)
    ) {
      //TODO:create a variable to identify that login should happen thrugh linkdetails and not props

      setTempLinkDetails(extractedURl);
      return extractedURl;
    } else {
      return false;
    }
  };
  const setInteractionIdFunction = (interactionIdRecieved) => {
    setIntereactionId(interactionId);
  };
  const setAgentScreenFunction = (agentStatus) => {
    console.log("TLOG:HELPASSISTANT AND STATUS RECIEVED IS", agentStatus);
    if (agentStatus !== undefined) {
      setAgentScreen(agentStatus.agentScreen);
      setAgentInfo(agentStatus);
      setAgentConnected(agentStatus?.agentConnected);
    }
    setgenesysWindowUpdate(agentStatus.refresher);
  };
  const setLoadingFunction = (data) => {
    setLoadingInAgent(true);
  };

  const linkDetection = (url) => {
    console.log(window.location.href, "URL");
    if (url.includes("action")) {
      setOutSideLink(true);
      setShow(true);
      // handleLogin();
      setshowOverlay(false);
      sendOnAppOpen();

      setShowClose(false);
      setShowMinimize(false);
      setMinimized(false);
      extractFromUrl(url);
    } else {
      if (props.action !== undefined && props.action !== null) {
        setActionFromConfig(props.action);
        if (props.hideLoading) {
          setOutSideLink(false);
        } else {
          setOutSideLink(false);
          setOverlayVisible(false);
        }
        actionInConfig(props);
      } else {
        if (props.hideLoading) {
          setshowOverlay(false);
          sendOnAppOpen();
          setShow(true);
          setShowClose(false);
          setShowMinimize(false);
          setMinimized(false);
        }
        setOutSideLink(false);
        setOverlayVisible(false);
      }
    }
  };
  const actionInConfig = (props) => {
    if (props?.action !== undefined || props?.action !== null) {
      if (props.hideLoading) {
        setShow(true);
        setOutSideLink(true);
        // handleLogin();
        setshowOverlay(false);
        sendOnAppOpen();
        setShowClose(false);
        setShowMinimize(false);
        setMinimized(false);
      }
    }
  };

  useEffect(() => {
    localStorage.setItem("s360ChatLoggedIn", "false");
    setshowOverlay(true);

    return () => {
      localStorage.removeItem("lastHdValue");
      localStorage.setItem("intereactionId", null);
    };
  }, []);

  useEffect(() => {
    if (!minimized) {
      startLogin();
      setOnClickYes(false);
      localStorage.setItem("onClickedYes", false);
    }
  }, [minimized]);

  useEffect(() => {
    setAuth(props.authenticated);
    // localStorage.removeItem("filterApllied");
  }, [props.authenticated]);
  //new addition 2

  useEffect(() => {
    linkDetection(window.location.href);
    setConversation(true);
    if (props.launchOnButton || window.location.href.includes("action")) {
      if (
        window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendNewOutsideLinkApi();
      } else if (
        props.action &&
        !window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendOutsideLinkApi();
      }
    }
  }, []);

  useEffect(() => {
    if (!showOverlay)
      console.log(
        "login end and show overlay removed",
        new Date().getUTCSeconds()
      );
  }, [showOverlay]);

  const sendOutsideLinkApi = () => {
    setLoggedInTillrefresh(true);
    let parentUrl = "";

    if (window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0) {
      parentUrl = window.location.ancestorOrigins[0];
    }

    const allowedOrigins = [
      "https://www.tataplay.com",
      "https://www.tataplaybinge.com",
    ];

    if (!parentUrl || !allowedOrigins.includes(parentUrl)) {
      console.error(
        "Unauthorized source origin:",
        parentUrl || "Missing origin"
      );
    

      alert("Unauthorized access. Please open the chatbot from the main portal.");
    
 
      try {
        Object.freeze(window);
      } catch (e) {
        console.warn("Window freeze failed:", e);
      }
    

      throw new Error("Unauthorized access - execution stopped.");
    }
    apiService
      .loginForLink(
        props.subscriberId,
        props.authenticated,
        props.action,
        props.openChat ? true : localStorage.getItem("jumpNode"),
        props.src || "Bot"
      )
      .then((response) => {
        console.log("first", new Date().getUTCSeconds());
        setStateSessionId(response?.data?.sessionId)
        chatReopenFunction(response.data.token, changedRefresh);
        localStorage.setItem("token", response.data.token);
        // if (response.data.userInfo !== undefined) {
        //   localStorage.setItem(
        //     "userName",
        //     JSON.stringify(response?.data?.userInfo?.customerName)
        //   );
        // } else {
        //   localStorage.setItem("userName", JSON.stringify("Testing"));
        // }
        if (response?.data?.userInfo?.customerName) {
          localStorage.setItem("userName", response.data.userInfo.customerName);
        } else {
          localStorage.setItem("userName", "Testing");
        }
        

        if (response?.data?.notif) {
          setIsDunningToast(true);
          setUserNotification(response.data.notif);

        }

        setLogin(true);

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }

        console.log("login end", new Date().getUTCSeconds());
      });
  };

  const sendNewOutsideLinkApi = () => {
    setChangedRefresh(false);
    const temp = extractFromUrl(window.location.href);
    console.log(temp, "tempnew");
    apiService
      .loginForLink(
        temp.subscriberId,
        temp.authenticated,
        temp.action,
        props.openChat ? true : localStorage.getItem("jumpNode"),
        temp.src || "Bot"
      )
      .then((response) => {
        setStateSessionId(response?.data?.sessionId)
        chatReopenFunction(response.data.token, changedRefresh);
        localStorage.setItem("token", response.data.token);

        // if (response.data.userInfo !== undefined) {
        //   localStorage.setItem(
        //     "userName",
        //     JSON.stringify(response?.data?.userInfo?.customerName)
        //   );
        // } else {
        //   localStorage.setItem("userName", JSON.stringify("Testing"));
        // }
        if (response?.data?.userInfo?.customerName) {
          localStorage.setItem("userName", response.data.userInfo.customerName);
        } else {
          localStorage.setItem("userName", "Testing");
        }

        if (response?.data?.notif) {
          setIsDunningToast(true);
          setUserNotification(response.data.notif);
          
        }

        setLogin(true);

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
      });
  };

  useEffect(() => {
    setThirdOkay(false);
    // console.log(typedFlag, "typedFlag");
  }, [typedFlag]);

  const coachScreenCloseFunc = () => {
    window.parent.postMessage(
      {
        resizeIframe: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };
  const closeEntireChat = () => {
    if (props.openChat) {
      return;
    }
    window.parent.postMessage(
      {
        closeChat: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };

  const handleCloseChat = () => {
    handleRefresh();
    // setShow(false);
    setShowBackToButton(false);
    setClearHistory(false);
    setShowMinimize(true);
    props.launchOnButton
      ? setShowAssistantToolTip(false)
      : setShowAssistantToolTip(true);
    setConversationData();
    setChatHistory([]);
    setShowWhatsappRegisterPopup(false);
    //  localStorage.removeItem("filterApllied");
  };

  const handleWhatsappRegisterNow = () => {
    setShowWhatsappRegisterPopup(true);
  };

  const handleCloseWhatsappRegistrationDone = () => {
    setShowClose(true);
  };
  const [scrollTop, setScrollTop] = useState(0);
  const [showBackToButton, setShowBackToButton] = useState(false);

  const myRef = useRef(null);

  const executeScroll = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
    //  handleRefresh();
  };

  const backToMenuFunction = () => {
    setShowBackToButton(false); //not affecting

    console.log("backToMenuFunction");
    setClearHistory(true);
    setBackToMenuRender(!backToMenuRender);
    restartChatOnBackToMenu(localStorage.getItem("token"));
    setIsSessionExpired(false);
    localStorage.removeItem("selectedChannelsPAcks");
    localStorage.removeItem("modPacks");
    setShowIdlePopup(false);
    setNudgeData(null);
  };

  const minimizeChat = () => {
    // setJumpNode(true);
    localStorage.setItem("jumpNode", true);
    window.parent.postMessage(
      {
        closeChat: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };

  const handleRefresh = () => {
    // setLoginLoader(false)
    // setLoginLoader(true)
  };

  const onScroll = (e) => {
    let element = e.target;

    if (element.scrollTop > 200) {
      //    console.log("scrolling after 200")
      setShowBackToButton(true);
    } else {
      setShowBackToButton(false);
    }
  };

  const handleHistory = () => {
    setHistoryLoader(true);
    apiService
      .historyApi(props.sessionId, props.source)
      .then((response) => {
        setHistoryLoader(false);
        // console.log("historyresponse", response.data);
        setHistoryData(response.data);
        setShowHistory(true);
      })
      .catch((error) => {
        setHistoryLoader(false);
      });
  };

  useEffect(() => {
    if (props.viewType === "history") {
      handleHistory();
      setSth(true);
    }
  }, []);

  useEffect(() => {
    if (!agentScreen) {
      setAgentHeader(false);
    }
    if (agentScreen) {
      setAgentHeader(true);
    }
  }, [genesysWindowUpdate]);
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onMessageSend();
    }
  };
  const sendMessageToAgent = () => {
    console.log("this message is sent to AGENT");
  };

  const fetchFeedbackUrlApi = (data) => {
    console.log(
      "logprod4 : Reached in  fetchFeedbackUrlApi",
      agentUserData,
      tempAgentData
    );

    let DataToSubmit = Constants.testLitmusData;
    if (tempAgentData === null || tempAgentData?.userData === undefined) {
      tempAgentData = agentUserData;
    }
    // DataToSubmit.app_id;
    DataToSubmit.customer_id = tempAgentData.userData.cti_SubscriberID;

    // DataToSubmit.tag_user_type:
    DataToSubmit.tag_city = tempAgentData.userData.cti_city;
    DataToSubmit.tag_subscriberId = tempAgentData.userData.cti_SubscriberID;
    // DataToSubmit.tag_source
    // DataToSubmit. tag_transType
    DataToSubmit.tag_interactionID = localStorage.getItem("intereactionId"); //props.sessionID
    DataToSubmit.user_email = tempAgentData.userData.EmailAddress;
    DataToSubmit.user_phone = tempAgentData.userData.PhoneNumber;
    DataToSubmit.tag_full_name =
      tempAgentData.userData.FirstName + tempAgentData.userData.LastName;
    DataToSubmit.tag_transcript =
      "ChatFileDownload?chatHistory=TataPlay ChatConversation History";
    DataToSubmit.tag_agentID = localStorage.getItem("agentId");

    if (data.agentName !== undefined) {
      DataToSubmit.tag_agent_name = data.agentName;
    } else {
      DataToSubmit.tag_agent_name = agentInfo.name;
    }
    console.log(
      "data to Submit in litmus : please remove this log",
      DataToSubmit
    );
    if (data.mode === "newTab") {
      apiService.generateLitmusFeedback(DataToSubmit).then((res) => {
        window.open(res?.data?.data?.long_url, "_blank");
      });
    } else if (data.mode === "iFrame") {
      let dataForAgentLogs = {
        message: "SENDING LITMUS TRIGGER",
        sessionID: secureLocalStorage.getItem("sessionID"),
        data: "FROM CROSS BUTTON ON TOP RIGHT",
        type: "CLIENTS360",
        secureKey: localStorage.getItem("sky"),
        timeStramp: new Date().getTime(),
      };
      console.log(dataForAgentLogs, "check logs for litmus");
      apiService.storeAgentLogs(dataForAgentLogs);

      apiService.generateLitmusFeedback(DataToSubmit).then((res) => {
        if (!res?.data?.data?.has_responded) {
          setFeedBackUrl(res?.data?.data?.long_url);
          setShowFeedBackIframe(true);
        } else {
          closeFeedBackIframe({ triggerScreen: "A80" });
          console.log("Already responded");
        }
      });
    }
    return;
  };
  const closeFeedBackIframe = () => {
    if (onClickYes) {
      //just close iframe

      if (
        props.launchOnButton === undefined ||
        !props.launchOnButton ||
        (props.openChat && props.launchOnButton)
      ) {
        window.parent.postMessage(
          {
            chatMinimized: "true",
          },
          "*" //or "www.parentpage.com"
        );
      }
      (props.openChat === null || props.openChat === undefined) &&
      props.launchOnButton
        ? closeEntireChat()
        : setShowAssistantToolTip(true);

      // setJumpNode(false)
      localStorage.setItem("jumpNode", false);
      // localStorage.removeItem('redirectLinkFullScreen');
      // handleCloseChat();

      // setSth(false);

      sendOnAppClose();
      setshowOverlay(false);
      setShowHistory(false);
      setTimeout(() => {
        setShowAssistantToolTip(false);
      }, 4000);
      setChangedRefresh(true);
      // setMaximized(true)
      setMinimized(true);
      setShowClose(false);
      setOnClickYes(false);
    }
    setShowFeedBackIframe(false);
    setFeedBackUrl("");
  };

  const addToastMessage = () => {
    setToast(true);
  };

  const onMessageSend = () => {
    let hasTextMessage = messageRef.current.value;
    // console.log("hasTextMessage", hasTextMessage);
    if (hasTextMessage.trim() === "") {
      addToastMessage();
      // console.log("textMessage", textMessage);

      // console.log("textMessage-setstate", textMessage);
    } else {
      setToast(false);
      setTextMessage({
        key1: messageRef.current.value,
        count: Math.random(0, 1),
      });
    }
    messageRef.current.value = "";
    setTimeout(() => {
      setTextMessage({
        key1: "",
        count: Math.random(0, 1),
      });
    }, 100);
  };

  const startLogin = () => {
    props.openChat && setChangedRefresh(false);

    if (props.action && !window.location.href.includes("action")) {
      if (loggedInTillrefresh) {
        setChangedRefresh(true);
        chatReopenFunction(localStorage.getItem("token"));
      } else if (
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendOutsideLinkApi();
      }
    } else {
      sendNewOutsideLinkApi();
    }
  };
  const handleChange = (e) => {
    // console.log("hiii", e.target.value);
    setTypedFlag(e.target.value);
    if (document.getElementById("tx").scrollHeight > 50) {
      document.getElementById("tx").style.overflowY = "scroll";
      // console.log("dd", document.getElementById("tx").style);
    }
  };

  const handleInputBox = (value) => {
    //change true /false for UAT PROD --->enable textbox
    if (value === undefined || value === null || value === false) {
      setEnableDefaultTextBox(false);
    } else {
      setEnableDefaultTextBox(true);
    }
  };
  const setUserDataForAgent = (data) => {
    console.log("logprod2 : data recieved in helpassistant a80", data);
    if (tempAgentData === null) {
      tempAgentData = data;
    }
    setAgentUserData(data);
    console.log("logprod3 : value after setting", agentUserData, tempAgentData);
  };

  const restartChatOnBackToMenu = (tokenData) => {
    setLoginLoader(true);
    console.log("login done and chat started", new Date().getUTCSeconds());
    apiService.chatForLink(tokenData, true).then((response) => {
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      console.log(data, "data in reopen");
      setChatData(data);
      handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      setLoginLoader(false);
      // setCurrentData(data);
      console.log("login done and chat done", new Date().getUTCSeconds());
    });
  };

  const chatReopenFunction = (tokenData) => {
    localStorage.setItem("token", tokenData);
    //get token which is set after logging in
    setLoginLoader(true);
    console.log("login done and chat started", new Date().getUTCSeconds());
    apiService.chatForLink(tokenData, changedRefresh).then((response) => {
      console.log("data in reopen", response);
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      if (response?.data?.notif) {
        setIsDunningToast(true);
        setUserNotification(response.data.notif);
      }
      setChatData(data);
      setReminderValue(response?.data?.chatResponse?.remainderData);
      handleInputBox(response?.data?.chatResponse?.enableDefaultTextBox);
      setLoginLoader(false);
      // setCurrentData(data);
      console.log("login done and chat done", new Date().getUTCSeconds());
    });

    //TODO : call apiService.chatReopenAPI
    //get the data from the api
    //pass it to conversation.jsx through props
  };

  const handleFeedbackCloseFlow = () => {
    let feedBackFlow = localStorage.getItem("onClickedYesFlow");
    if (feedBackFlow === "true") {
      apiService
        .feedbackCloseButton(localStorage.getItem("token"))
        .then((response) => {
          console.log("data in reopen", response);
          localStorage.setItem("onClickedYesFlow", false);
        });
    }
  };
  const handleThirdOkay = () => {
    setThirdOkay(false);
  };
  const handleNewLink = () => {
    localStorage.setItem("redirectLinkFullScreen", true);
  };

  useEffect(() => {
    let El = document.getElementById("s360ChatSectionContainer");
    console.log(agentScreen, "agent screen");

    if (agentScreen) {
      setShowBackToButton(false);
      if (El) El.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [genesysWindowUpdate]);

  const handleLogin = () => {
    apiService
      .loginForLink(props.subscriberId, props.authenticated)
      .then((response) => {
        console.log("login done", response);

        chatReopenFunction(response.data.token, changedRefresh);
        localStorage.setItem("token", response?.data?.token);

         // if (response.data.userInfo !== undefined) {
        //   localStorage.setItem(
        //     "userName",
        //     JSON.stringify(response?.data?.userInfo?.customerName)
        //   );
        // } else {
        //   localStorage.setItem("userName", JSON.stringify("Testing"));
        // }
        if (response?.data?.userInfo?.customerName) {
          localStorage.setItem("userName", response.data.userInfo.customerName);
        } else {
          localStorage.setItem("userName", "Testing");
        }

        setLogin(true);

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }

        setClearHistory(true);
        setBackToMenuRender(!backToMenuRender);
        restartChatOnBackToMenu(localStorage.getItem("token"));
        setIsSessionExpired(false);
        localStorage.removeItem("selectedChannelsPAcks");
        localStorage.removeItem("modPacks");
        setShowIdlePopup(false);
        setShowIdlePopup(false);
      });
  };

  return (
    <Fragment>
      {showFeedBackIframe && (
        <FeedBackIframe
          closeFeedBackIframe={closeFeedBackIframe}
          feedbackUrl={feedbackUrl}
        />
      )}
      {props.viewType === "history" ? (
        <div>
          <div
            onScroll={onScroll}
            className="help-chat-box chatIn-header-hist help-assistantwrapp-hist hbc0 maximize"
            id="top "
          >
            {agentHeader ? (
              <div
                id="help-card-header"
                className="help-card-header left-gradient"
                style={{
                  height: "52px",
                  display: "block",
                  textAlign: agentHeader ? "left" : "center",
                }}
              >
                <span className="chat-avtar">
                  <img src={helpicon} alt="" />
                </span>
                <span className="chat-avtar-detail bold">{agentInfo.name}</span>
              </div>
            ) : (
              <div
                id="help-card-header"
                className="help-card-header left-gradient"
                style={{ display: "block", height: "52px" }}
              >
                <span className="chat-avtar">
                  <img src={helpicon} alt="" />
                </span>
                <span className="chat-avtar-detail bold">
                  {" "}
                  Get help Assistant{" "}
                </span>
              </div>
            )}

            <div
              className={
                agentScreen
                  ? " help-card-body no-scroll my-custom-scrollbar my-custom-scrollbar-primary  "
                  : "help-card-body my-custom-scrollbar my-custom-scrollbar-primary"
              }
              onScroll={onScroll}
              style={{ height: "100%" }}
              id="s360ChatSectionContainer"
            >
              {showBackToButton && !agentConnected && (
                <>
                  <div
                    className={agentScreen ? "bktotop-hidden" : "bktotop"}
                    style={{
                      minWidth: "398px",
                      width: document.getElementById("top").clientWidth,
                      top: document.getElementById("help-card-header")
                        .clientHeight,
                    }}
                    key={agentConnected}
                  >
                    <button
                      onClick={() => {
                        backToMenuFunction();
                      }}
                      className="button"
                    >
                      <span>
                        <img src={backtopmenu} alt="" />
                      </span>
                      Back to menu
                    </button>
                  </div>
                </>
              )}
              <div className="firstblk chat-section" id="section0" ref={myRef}>
                {conversation && (
                  <Conversation
                    //new addition3
                    setUserDataForAgent={setUserDataForAgent}
                    disconnectInA80={onClickYes}
                    closeFeedBackIframe={closeFeedBackIframe}
                    fetchFeedbackUrlApi={fetchFeedbackUrlApi}
                    setLoadingFunction={setLoadingFunction}
                    setAgentScreenFunction={setAgentScreenFunction}
                    setInteractionIdFunction={setInteractionIdFunction}
                    isLoading={isLoading}
                    currentData={currentData}
                    //
                    chatData={chatData}
                    jumpNode={jumpNode}
                    setLoginFromProps={(data) => setLogin(data)}
                    actionConfig={actionFromConfig}
                    {...props}
                    setLoginLoader={setLoginLoader}
                    setLogin={setLogin}
                    historyData={historyData}
                    setHistoryData={setHistoryData}
                    sth={sth}
                    showHistory={showHistory}
                    historyLoader={historyLoader}
                    loginLoader={loginLoader}
                    name={name}
                    login={login}
                    auth={auth}
                    setAuth={setAuth}
                    handleInputBox={handleInputBox}
                    handleDontSend={() =>
                      setTextMessage({
                        key1: "",
                        count: Math.random(0, 1),
                        dontSend: true,
                      })
                    }
                    outSideLink={outSideLink}
                    tempLinkDetails={tempLinkDetails}
                    userClickedOnYes={onClickYes}
                    setShowFeedbackPopUP={setShowFeedbackPopUP}
                  />
                )}
                {/* {console.log("ha-con227")} */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* {!overlayVisible && showOverlay && ( */}
          {coachingData === true && !overlayVisible && showOverlay && (
            <>
              {" "}
              <div className="black-overlay fix"></div>
              {!overlayVisible && !showSecondOk ? (
                <div className="instr1">
                  {/* {console.log("ha-showSecondOk", showSecondOk)} */}
                  <div>
                    Click on the Get Help assistant to get your queries resolved
                  </div>
                  <div>
                    <button
                      className="btn btn-primary waves-effect waves-light w-auto mT10 btn1"
                      onClick={handleButtonClick}
                    >
                      Ok, got it
                    </button>
                  </div>
                  <div className="arrow"></div>
                </div>
              ) : (
                <>
                </>
              )}{" "}
            </>
          )}

          <div className="pfixed">
            {minimized &&
              // && !showMinimize
              showAssistantToolTip && (
                <div className="chattooltip bounce1" timeOut={2000}>
                  Ask Assistant
                </div>
              )}
            {showMinimize && showChatToolTip ? (
              <>
                {showChatInProgressToolTip && (
                  <div className="msgnum bounce1">Chat in Progress</div>
                )}

                {!minimized && (
                  <div
                    className="help-stick"
                    onClick={() => {
                      if (!showOverlay) {
                        setShowBackToButton(false);
                        setMinimized(false);
                        if (
                          props.launchOnButton === undefined ||
                          !props.launchOnButton ||
                          props.openChat
                        ) {
                          window.parent.postMessage(
                            {
                              chatMaximized: "true",
                            },
                            "*" //or "www.parentpage.com"
                          );
                        }

                        props.launchOnButton === undefined ||
                          !props.launchOnButton ||
                          (props.openChat && handleHistory());
                        sendOnAppOpen();
                        setShow(true);
                        setMaximized(true);
                        setShowClose(false);
                        setShowMinimize(false);
                        sth && setSth(true);
                        // startLogin()
                      }
                    }}
                  >
                    <div className="help-man ">
                      <img src={femaleuser} height="30" alt="" />
                      {/* {console.log("ha-pfixed")} */}
                    </div>
                    <div className="help-text">
                      Get Help <br />
                      Assistant
                    </div>
                  </div>
                )}
              </>
            ) : (
              //this is where minimized is true and icon appears
              minimized && (
                <div
                  className="help-stick"

                  onClick={() => {
                    if (!showOverlay) {
                      window.parent.postMessage(
                        {
                          chatMaximized: "true",
                        },
                        "*" //or "www.parentpage.com"
                      );
                      setMinimized(false);
                    }
                    if (login) {
                      window.parent.postMessage(
                        {
                          chatMaximized: "true",
                        },
                        "*" //or "www.parentpage.com"
                      );
                      !props.launchOnButton &&
                        chatReopenFunction(localStorage.getItem("token"));
                    }
                    // }else{
                    //   startLogin()
                    // }
                    // localStorage.setItem("linkLoginOnce", true);
                    //  localStorage.removeItem("linkLoginOnce");

                    // setShowSecondOk(true);
                    // sendOnAppOpen();
                    // setMaximized(true);
                    // setShow(true);
                    // setShowClose(false);
                    // setShowMinimize(false);
                  }}
                >
                  <div className="help-man">
                    <img src={femaleuser} height="30" alt="" />
                  </div>
                  <div className="help-text">
                    Get Help <br />
                    Assistant
                  </div>
                </div>
              )
            )}
          </div>
     
          {!minimized && (
            <>
              <div
                  onScroll={onScroll}
                  className="help-chat-box chatIn-header help-assistantwrapp hbc0 maximize"
                  style={{ visibility: maximized ? "visible" : "hidden" }}
                  id="top"
                  key={backToMenuRender}
                >
                  {showFeedbackPopUP && <div
                    onScroll={onScroll}
                    className="help-chat-box chatIn-header help-assistantwrapp hbc0 maximize"
                    style={{ visibility: maximized ? "visible" : "hidden" }}
                    id="top"
                    key={backToMenuRender}
                  >
                    <button
                      onClick={() => {
                        setShowFeedbackPopUP(null);
                      }}
                      style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        background: 'transparent',
                        border: 'none',
                        fontSize: '24px',
                        color: '#555',
                        cursor: 'pointer',
                        zIndex: 21,
                      }}
                      aria-label="Close"
                    >
                      &times;
                    </button>
                    <iframe style={{ height: "100vh" }} src={showFeedbackPopUP}></iframe>
               </div>}
              {showClose && (
                <>
                  <div className="chat-blkoverlay" style={{ display: "block" }}>
                    {/* {console.log("ha-301")} */}
                    <div
                      className="confirmContr"
                      style={{ zIndex: 999999999999999 }}
                    >
                      <p style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        {" "}
                        Are you sure you want to close this conversation?
                      </p>
                      <div className="btn-contr mT20">
                        <button
                          className="btn btn-primary waves-effect waves-light w-auto chatclose-yes"
                          style={{
                            cursor: "pointer",
                            height: "36px",
                            lineHeight: "35px",
                          }}
                          onClick={() => {
                            localStorage.setItem("onClickedYes", true);

                            handleFeedbackCloseFlow();
                            console.log(
                              "PLOG: CLICKED ON CLOSE BUTTON ",
                              agentUserData,
                              tempAgentData
                            );
                            localStorage.removeItem("lastHdValue");
                            setShowBackToButton(false);

                            setOnClickYes(true);
                            console.log(
                              props.launchOnButton,
                              props.openChat,
                              "issueiss"
                            );
                            const condition =
                              localStorage
                                .getItem("agentDisconnected")
                                ?.toString() === "false" &&
                              localStorage.getItem("litmusApiCallEnabled") !==
                                undefined &&
                              localStorage
                                .getItem("litmusApiCallEnabled")
                                .toString() !== "false";
                            console.log("condition", condition);
                            if (condition) {
                              //TO ITMUS
                              setTimeout(() => {
                                fetchFeedbackUrlApi({ mode: "iFrame" });
                              }, 1500);
                            } else {
                              if (
                                props.launchOnButton === undefined ||
                                !props.launchOnButton ||
                                (props.openChat && props.launchOnButton)
                              ) {
                                window.parent.postMessage(
                                  {
                                    chatMinimized: "true",
                                  },
                                  "*" //or "www.parentpage.com"
                                );
                              }
                              (props.openChat === null ||
                                props.openChat === undefined) &&
                              props.launchOnButton
                                ? closeEntireChat()
                                : setShowAssistantToolTip(true);

                              // setJumpNode(false)
                              localStorage.setItem("jumpNode", false);
                              // localStorage.removeItem('redirectLinkFullScreen');
                              // handleCloseChat();

                              // setSth(false);

                              sendOnAppClose();
                              setshowOverlay(false);
                              setShowHistory(false);
                              setTimeout(() => {
                                setShowAssistantToolTip(false);
                              }, 4000);
                              setChangedRefresh(true);
                              // setMaximized(true)
                              setMinimized(true);
                              setShowClose(false);
                            }
                            localStorage.setItem("disconnectInA80", true);
                            setTimeout(() => {
                              setIsDunningToast(true);
                            }, 5000);
                          }}
                        >
                          Yes
                        </button>
                        <button
                          style={{
                            border: "1px solid #E1009D",
                            cursor: "pointer",
                            height: "36px",
                            textAlign: "center",
                            lineHeight: "35px",
                          }}
                          className="btn    waves-effect waves-light w-auto chatclose-no "
                          onClick={() => {
                            setShowClose(false);
                            // setOnClickYes(true);
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* {thirdOkay && <div className="black-overlay fix" style={{ display: "block" }}></div>} */}
              {!agentHeader ? (
                <div
                  id="help-card-header"
                  className={
                    showIdlePopup && !isChatWithUs
                      ? "idle-pop-header-hidden"
                      : "help-card-header left-gradient"
                  }
                  style={{ height: "52px" }}
                >
                  <span
                    className="chat-avtar"
                    onClick={() => {
                      setShowVersion(true);
                      setTimeout(() => {
                        setShowVersion(false);
                      }, 2000);
                    }}
                  >
                    <img src={helpicon} alt="" />
                  </span>
                  <span className="chat-avtar-detail bold">
                    {" "}
                    Get help Assistant{" "}
                  </span>

                  <i
                    className="icon-minus-1 mR10"
                    style={{ cursor: "pointer" }}
                    key="miniMizeButtonS360Chart"
                    onClick={() => {
                      if (
                        props.launchOnButton === undefined ||
                        !props.launchOnButton ||
                        props.openChat
                      ) {
                        window.parent.postMessage(
                          {
                            chatMinimized: "true",
                          },
                          "*" //or "www.parentpage.com"
                        );
                      }
                      localStorage.setItem("jumpNode", true);
                      setMaximized(false);
                      setShowMinimize(true);

                      // // // localStorage.removeItem("filterApllied");
                      setShow(false);
                      setShowChatToolTip(true);
                      // setSth(true)
                      sendOnAppClose();
                      setshowOverlay(false);

                      setTextMessage({
                        key1: "",
                        count: Math.random(0, 1),
                        dontSend: true,
                      });
                      setShowBackToButton(false);
                      setShowChatInProgressToolTip(true);
                      setTimeout(() => {
                        setShowChatInProgressToolTip(false);
                      }, 5000);
                      if (
                        props.launchOnButton &&
                        (props.openChat === undefined ||
                          props.openChat === null)
                      )
                        minimizeChat();
                    }}
                  ></i>
                  <i
                    className="icon-close-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setChatData([]);
                      setChatClosed(true);
                      setAgentHeader(false);
                      setShowClose(true);
                      setTextMessage({
                        key1: "",
                        count: Math.random(0, 1),
                        dontSend: true,
                      });
                      handleRefresh();
                    }}
                  ></i>
                </div>
              ) : (
                <div
                  id="help-card-header"
                  className="help-card-header left-gradient"
                  style={{
                    textAlign: agentHeader ? "left" : "center",
                    height: "52px",
                  }}
                >
                  <span className="chat-avtar">
                    <img src={helpicon} alt="" />
                  </span>
                  <div style={{ width: "100%", height: "100%" }}>
                    <div>
                      <span className="chat-avtar-detail bold">
                        {agentInfo.name}
                      </span>
                    </div>

                    <div className="liveAgentSmallHeader">
                      <small>(Live Agent)</small>
                    </div>
                  </div>

                  {/* when we get download icon put it here  */}

                  <i
                    className="icon-close-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setChatData([]);
                      setChatClosed(true);
                      setAgentHeader(false);
                      setShowClose(true);
                      setTextMessage({
                        key1: "",
                        count: Math.random(0, 1),
                        dontSend: true,
                      });
                      handleRefresh();
                    }}
                  ></i>
                </div>
              )}

              <div
                className={
                  agentScreen
                    ? "help-card-body no-scroll my-custom-scrollbar my-custom-scrollbar-primary   "
                    : "help-card-body my-custom-scrollbar my-custom-scrollbar-primary"
                }
                onScroll={onScroll}
                id="s360ChatSectionContainer"
              >
                {showVersion && Constants.env === "UAT" && (
                  <div className="version-notify">{`Version - ${Constants.version}`}</div>
                )}
                {!agentConnected && (
                  <>
                    <div
                      className={agentScreen ? "bktotop-hidden" : "bktotop"}
                      style={{
                        minWidth: "398px",
                        width: document?.getElementById("top")?.clientWidth,
                        top: document?.getElementById("help-card-header")
                          ?.clientHeight,
                      }}
                      key={agentConnected}
                    >
                      <button
                        onClick={() => {
                          showIdlePopup ? handleLogin() : backToMenuFunction();
                        }}
                        className="button"
                      >
                        <span>
                          <img src={backtopmenu} alt="" />
                        </span>{" "}
                        Back to menu
                      </button>
                    </div>
                  </>
                )}

                <audio id="myAudio">
                  <source src="../done.mp3" type="audio/mpeg" />
                  Your browser does not support the audio element.{" "}
                </audio>
                <div
                  className="firstblk chat-section"
                  id="section0"
                  ref={myRef}
                >
                  {conversation && (
                    <Conversation
                      setUserDataForAgent={setUserDataForAgent}
                      disconnectInA80={onClickYes}
                      closeFeedBackIframe={closeFeedBackIframe}
                      fetchFeedbackUrlApi={fetchFeedbackUrlApi}
                      setLoadingFunction={setLoadingFunction}
                      setAgentScreenFunction={setAgentScreenFunction}
                      setInteractionIdFunction={setInteractionIdFunction}
                      //new addition 4
                      isLoading={isLoading}
                      currentData={currentData}
                      //
                      chatData={chatData}
                      reminderValue={reminderValue}
                      jumpNode={jumpNode}
                      setLoginFromProps={(data) => setLogin(data)}
                      actionConfig={actionFromConfig}
                      thirdOkay={thirdOkay}
                      handleThirdOkay={handleThirdOkay}
                      {...props}
                      historyData={historyData}
                      setLoginLoader={setLoginLoader}
                      setLogin={setLogin}
                      setHistoryData={setHistoryData}
                      sth={sth}
                      showHistory={showHistory}
                      historyLoader={historyLoader}
                      loginLoader={loginLoader}
                      name={name}
                      login={login}
                      auth={auth}
                      setAuth={setAuth}
                      textMessage={textMessage}
                      handleInputBox={handleInputBox}
                      handleDontSend={() =>
                        setTextMessage({
                          key1: "",
                          count: Math.random(0, 1),
                          dontSend: true,
                        })
                      }
                      outSideLink={outSideLink}
                      tempLinkDetails={tempLinkDetails}
                      chatClosed={chatClosed}
                      setChatClosed={setChatClosed}
                      setShowClose={setShowClose}
                      setMinimized={setMinimized}
                      userClickedOnYes={onClickYes}
                      typedFlag={typedFlag}
                      isSessionExpired={isSessionExpired}
                      setIsSessionExpired={setIsSessionExpired}
                      setShowIdlePopup={setShowIdlePopup}
                      isChatWithUs={isChatWithUs}
                      setIsChatWithUs={setIsChatWithUs}
                      isDunningToast={isDunningToast}
                      setIsDunningToast={setIsDunningToast}
                      setUserNotification={setUserNotification}
                      setChatData={setChatData}
                      setShowFeedbackPopUP={setShowFeedbackPopUP}

                      setNudgeData={setNudgeData}
                      nudgeData={nudgeData}
                      setNudgeHandleClick={(fn) => window.nudgeHandleClick = fn}
                      
                    />
                  )}
                </div>
                {showIdlePopup && !isChatWithUs && (
                  <div className="idle-msg-container">
                    <p className="idle-msg-container-content">
                      <span style={{ fontWeight: "bold" }}>
                        Since it's been a while and there is no revert from you
                        yet, we'll have to close the chat window. But drop by
                        again anytime in case you start missing us. We loved
                        hearing from you. Have a great day!
                      </span>
                      <span
                        style={{
                          fontWeight: "bold",
                          display: "block",
                          marginTop: 10,
                          fontSize: 18,
                        }}
                      >
                        Please click on Back to Menu.
                      </span>
                    </p>
                  </div>
                )}
              </div>
              {toast && (
                <ToastMessage
                  message="Please enter appropriate text."
                  clickedOnToast={() => setToast(false)}
                />
              )}
              {nudgeData && (
                <MessageA13Nudge
                  item={nudgeData}
                  handleClick={() => {}}
                  setTextOnClick={() => {}}
                  clickedOnToast={() => setNudgeData(null)}
                  sessionId={props?.sessionId || stateSessionId}
                />
              )}
              {enableDefaultTextBox &&
              !agentScreen &&
              !isSessionExpired &&
              conversation ? (
                <div className="text-area-input-box-container action-tab">
                  <textarea
                    id="tx"
                    maxRows={4}
                    style={{
                      maxHeight: "128px",
                      opacity: enableDefaultTextBox ? "100%" : "50%",
                    }}
                    ref={messageRef}
                    className="text-area-input-box"
                    aria-label="empty textarea"
                    placeholder="Type your query..."
                    onChange={(e) => handleChange(e)}
                    onKeyPress={handleKeyPress}
                    disabled={!enableDefaultTextBox}
                  />

                  {/* <div onClick={onMessageSend}>
                                <img style={{cursor:"pointer"}}  src={attachIcon} alt={attachIcon} height="20px" width="20px" />
                            </div> */}
                  <div onClick={onMessageSend}>
                    {typedFlag.length === 0 ? (
                      <img
                        style={{ cursor: "pointer" }}
                        src={sendIconGrey}
                        alt={sendIcon}
                        height="20px"
                        width="20px"
                        onClick={() => handleNewLink()}
                      />
                    ) : (
                      <img
                        style={{ cursor: "pointer" }}
                        src={sendIcon}
                        alt={sendIconGrey}
                        height="20px"
                        width="20px"
                      />
                    )}
                  </div>
                </div>
              ) : null}
              {isDunningToast && userNotification?.text && (
                <div className="dunning-toast-wrapper">
                  <div className="warning-icon">
                    <WarningAmberIcon className="warning-icon" />
                  </div>
                  <div className="dunning-toast-content">
                    <h4
                      dangerouslySetInnerHTML={{
                        __html: userNotification?.text,
                      }}
                    ></h4>
                    <a
                      href={userNotification?.link}
                      target="_blank"
                      onClick={() => {
                        setIsDunningToast(false);
                      }}
                    >
                      {userNotification?.context}
                    </a>
                  </div>
                  <div className="close-icon">
                    <CloseOutlinedIcon
                      className="dunning-toast-close-icon"
                      onClick={() => setIsDunningToast(false)}
                    />
                  </div>
                </div>
              )}
            </div>
            </>
          )}
        </>
      )}
    </Fragment>
  );
};

export default HelpAssistant;
